import { useExperienceMasterDataApi } from "@/composables/useExperienceMasterDataApi";
import { useQuery } from "@tanstack/vue-query";

export function useExperienceCategoriesMasterdataQuery() {
  const experienceMasterDataApi = useExperienceMasterDataApi();
  return useQuery({
    queryKey: ["experience-categories-masterdata"],
    queryFn: () => experienceMasterDataApi.getCategories(),
    select: ({ data }) => data,
  });
}
